import React, { useEffect, useState } from "react";
import { Clock, Calendar, CheckCircle, XCircle, BarChart3 } from "lucide-react";
import { useGetUseBookingCount } from "@/hooks/useCommon";
import { useAuth } from "@/store/auth";
interface MetricCardProps {
  title?: string;
  value?: any;
  trend?: "up" | "down";
  icon?: React.ReactNode;
  color?: string;
}
interface BookingCount {
  current_booking: number;
  future_booking: number;
  completed_booking: number;
  pending_booking: number;
  cancelled_booking: number;
}

const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  trend,
  icon,
  color,
}) => {
  const { user } = useAuth();
  const { mutate } = useGetUseBookingCount();
  const [data, setData] = useState<BookingCount>();

  useEffect(() => {
    mutate(
      {
        user_id: user?.id,
        user_type_id: user?.user_type_id,
      },
      {
        onSuccess: (res) => {
          setData(res?.responseData?.response?.data?.data || {});
        },
      }
    );
  }, []);
  const metricsData: MetricCardProps[] = [
    {
      title: "Current",
      value: `${data?.current_booking ?? 0}`,
      trend: "up",
      icon: <Clock className="w-5 h-5 text-blue-200" />,
      color: "bg-blue-400",
    },
    {
      title: "Future",
      value: `${data?.future_booking ?? 0}`,
      trend: "up",
      icon: <Calendar className="w-5 h-5 text-green-200" />,
      color: "bg-[#3ca731]",
    },
    {
      title: "Completed",
      value: `${data?.completed_booking ?? 0}`,
      trend: "up",
      icon: <CheckCircle className="w-5 h-5 text-emerald-200" />,
      color: "bg-[#55BD42]",
    },
    {
      title: "Cancelled",
      value: `${data?.cancelled_booking ?? 0}`,
      trend: "down",
      icon: <XCircle className="w-5 h-5 text-red-200" />,
      color: "bg-orange-300",
    },
    {
      title: "Total",
      value: `${
        (data?.current_booking || 0) +
        (data?.future_booking || 0) +
        (data?.completed_booking || 0) +
        (data?.cancelled_booking || 0)
      }`,

      trend: "up",
      icon: <BarChart3 className="w-5 h-5 text-purple-200" />,
      color: "bg-purple-300",
    },
    {
      title: "Total Revenue",
      value: "2,450",
      trend: "up",
      icon: <BarChart3 className="w-5 h-5 text-purple-200" />,
      color: "bg-pink-300",
    },
  ];

  return (
    <div className="grid grid-cols-6 justify-evenly gap-3">
      {metricsData.map(({ title, value, color }, id) => (
        <div
          key={id}
          className={` px-3 py-5 shadow-md cursor-pointer rounded-sm ${color} flex justify-between items-center`}
        >
          <div className="flex flex-col">
            <span className="text-[14px]  text-gray-700">{value}</span>
            <span className="text-white text-[14px]">{title}</span>
          </div>
          <div className="graph">
            <div className="flex gap-1 items-end">
              <div className="bg-white/30 h-6 w-2"></div>
              <div className="bg-white/30 h-12 w-2"></div>
              <div className="bg-white/30 h-8 w-2"></div>
              <div className="bg-white/30 h-10 w-2"></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MetricCard;
